/* Dayvee – Großansicht für Produktbilder (Lightbox mit Zoom)
   - Klick/Tipp auf das große Produktbild oder die Lupe öffnet die Großansicht
   - Blättern: Pfeile, Pfeiltasten, Wischen
   - Zoom: Klick (Maus, Ausschnitt folgt der Maus), Doppeltipp oder zwei Finger (Touch)
   - Schließen: X, Esc, Tipp auf den Hintergrund, nach unten wischen
   Liest nur die vorhandene Galerie aus (data-dpv2-main, data-dpv2-thumb), ändert sie nicht. */
(function(){
  var root = document.querySelector('[data-dpv2]');
  if (!root) return;
  var wrap = root.querySelector('.dpv2-main-img');
  if (!wrap || !root.querySelector('[data-dpv2-main]')) return;

  var ZOOM = 2.5, W = 1200;

  var css = ''
  + '.dpv2-main-img{position:relative}'
  + '.dpv2-main-img [data-dpv2-main]{cursor:zoom-in}'
  + '.dpvz-hint{position:absolute;right:10px;bottom:10px;width:38px;height:38px;border-radius:50%;border:1px solid #e7e1d8;background:rgba(255,255,255,.92);color:#1e3a5f;display:flex;align-items:center;justify-content:center;cursor:pointer;padding:0;box-shadow:0 2px 8px rgba(20,30,40,.08);transition:transform .15s ease}'
  + '.dpvz-hint:hover{transform:scale(1.06)}'
  + '.dpvz-hint:focus-visible,.dpvz-btn:focus-visible{outline:2px solid #fff;outline-offset:2px}'
  + '.dpvz-hint:focus-visible{outline-color:#1e3a5f}'
  + '.dpvz{position:fixed;inset:0;z-index:2147483000;background:rgba(14,20,32,.985);display:none;outline:none;touch-action:none;-webkit-user-select:none;user-select:none}'
  + '.dpvz.is-open{display:block}'
  + 'html.dpvz-lock,html.dpvz-lock body{overflow:hidden!important}'
  + '.dpvz-stage{position:absolute;inset:56px 0 56px 0;overflow:hidden;display:flex;align-items:center;justify-content:center}'
  + '.dpvz-img{max-width:min(92vw,1200px);max-height:100%;width:auto;height:auto;object-fit:contain;transform-origin:center center;will-change:transform;cursor:zoom-in;-webkit-user-drag:none;background:#f8f6f2;border-radius:6px}'
  + '.dpvz.is-zoomed .dpvz-img{cursor:zoom-out;border-radius:0}'
  + '.dpvz-img.is-anim{transition:transform .22s ease}'
  + '.dpvz-btn{position:absolute;width:44px;height:44px;border-radius:50%;border:0;background:rgba(14,20,32,.62);color:#fff;box-shadow:0 0 0 1px rgba(255,255,255,.18);display:flex;align-items:center;justify-content:center;cursor:pointer;padding:0;transition:background .15s ease}'
  + '.dpvz-btn:hover{background:rgba(14,20,32,.85)}'
  + '.dpvz-btn[hidden]{display:none}'
  + '.dpvz-close{top:8px;right:8px}'
  + '.dpvz-prev{left:12px;top:50%;margin-top:-22px}'
  + '.dpvz-next{right:12px;top:50%;margin-top:-22px}'
  + '.dpvz-count{position:absolute;top:18px;left:0;right:0;text-align:center;color:rgba(255,255,255,.8);font-size:14px;letter-spacing:.04em;pointer-events:none}'
  + '.dpvz-tip{position:absolute;bottom:18px;left:0;right:0;text-align:center;color:rgba(255,255,255,.62);font-size:13px;pointer-events:none}'
  + '@media (max-width:749px){.dpvz-prev,.dpvz-next{top:auto;bottom:6px;margin-top:0}.dpvz-prev{left:8px}.dpvz-next{right:8px}.dpvz-stage{inset:56px 0 60px 0}.dpvz-img{max-width:100vw;border-radius:0}}';
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  var ICON_ZOOM = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5M11 8v6M8 11h6"/></svg>';
  var ICON_X = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>';
  var ICON_L = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m15 6-6 6 6 6"/></svg>';
  var ICON_R = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 6 6 6-6 6"/></svg>';

  /* Lupe am Produktbild */
  var hint = document.createElement('button');
  hint.type = 'button';
  hint.className = 'dpvz-hint';
  hint.setAttribute('aria-label', 'Bild vergrößern');
  hint.innerHTML = ICON_ZOOM;
  wrap.appendChild(hint);

  /* Großansicht */
  var box = document.createElement('div');
  box.className = 'dpvz';
  box.setAttribute('role', 'dialog');
  box.setAttribute('aria-modal', 'true');
  box.setAttribute('aria-label', 'Produktbild in Großansicht');
  box.tabIndex = -1;
  box.innerHTML = '<div class="dpvz-count" aria-live="polite"></div>'
    + '<div class="dpvz-stage"><img class="dpvz-img" alt="" draggable="false"></div>'
    + '<button type="button" class="dpvz-btn dpvz-prev" aria-label="Vorheriges Bild">' + ICON_L + '</button>'
    + '<button type="button" class="dpvz-btn dpvz-next" aria-label="Nächstes Bild">' + ICON_R + '</button>'
    + '<button type="button" class="dpvz-btn dpvz-close" aria-label="Großansicht schließen">' + ICON_X + '</button>'
    + '<div class="dpvz-tip"></div>';
  document.body.appendChild(box);

  var stage = box.querySelector('.dpvz-stage');
  var img = box.querySelector('.dpvz-img');
  var countEl = box.querySelector('.dpvz-count');
  var tipEl = box.querySelector('.dpvz-tip');
  var btnPrev = box.querySelector('.dpvz-prev');
  var btnNext = box.querySelector('.dpvz-next');
  var btnClose = box.querySelector('.dpvz-close');

  var list = [], idx = 0, lastFocus = null;
  var s = 1, tx = 0, ty = 0;
  var coarse = window.matchMedia && window.matchMedia('(pointer:coarse)').matches;

  function sized(u){
    if (!u) return u;
    u = u.replace(/([?&])width=\d+/, '$1width=' + W);
    if (!/[?&]width=/.test(u)) u += (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + W;
    return u;
  }
  function key(u){ return (u || '').split('?')[0].replace(/^https?:/, ''); }

  function build(){
    var main = root.querySelector('[data-dpv2-main]');
    var mainSrc = main ? (main.currentSrc || main.src) : '';
    var thumbs = root.querySelectorAll('[data-dpv2-thumb]');
    list = [];
    var start = -1;
    thumbs.forEach(function(b, i){
      list.push(sized(b.getAttribute('data-dpv2-thumb')));
      if (b.getAttribute('aria-current') === 'true') start = i;
    });
    if (start < 0 && mainSrc){
      for (var i = 0; i < list.length; i++){ if (key(list[i]) === key(mainSrc)){ start = i; break; } }
    }
    if (start < 0 && mainSrc){ list.unshift(sized(mainSrc)); start = 0; }
    if (!list.length) return false;
    idx = Math.max(0, start);
    return true;
  }

  function apply(anim){
    img.classList.toggle('is-anim', !!anim);
    img.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + s + ')';
    box.classList.toggle('is-zoomed', s > 1.01);
  }
  function limits(scale){
    var w = img.offsetWidth, h = img.offsetHeight;
    var sw = stage.clientWidth, sh = stage.clientHeight;
    return { x: Math.max(0, (w * scale - sw) / 2), y: Math.max(0, (h * scale - sh) / 2), w: w, h: h };
  }
  function clamp(){
    var L = limits(s);
    tx = Math.max(-L.x, Math.min(L.x, tx));
    ty = Math.max(-L.y, Math.min(L.y, ty));
  }
  function reset(anim){ s = 1; tx = 0; ty = 0; apply(anim); }

  /* Zoom auf einen Punkt (Bildschirmkoordinaten) */
  function zoomAt(cx, cy, scale, anim){
    var r = stage.getBoundingClientRect();
    var px = cx - (r.left + r.width / 2), py = cy - (r.top + r.height / 2);
    var qx = (px - tx) / s, qy = (py - ty) / s;
    s = scale;
    tx = px - s * qx; ty = py - s * qy;
    clamp(); apply(anim);
  }
  /* Maus: Ausschnitt folgt dem Zeiger */
  function follow(cx, cy){
    var r = stage.getBoundingClientRect();
    var L = limits(s);
    var fx = (cx - r.left) / r.width - .5, fy = (cy - r.top) / r.height - .5;
    tx = -fx * 2 * L.x; ty = -fy * 2 * L.y;
    clamp(); apply(false);
  }

  function show(i){
    idx = (i + list.length) % list.length;
    reset(false);
    img.src = list[idx];
    var multi = list.length > 1;
    btnPrev.hidden = btnNext.hidden = !multi;
    countEl.textContent = multi ? (idx + 1) + ' / ' + list.length : '';
    if (multi){
      [list[(idx + 1) % list.length], list[(idx - 1 + list.length) % list.length]].forEach(function(u){ var p = new Image(); p.src = u; });
    }
  }

  function open(){
    if (!build()) return;
    lastFocus = document.activeElement;
    tipEl.textContent = coarse ? 'Doppeltippen oder mit zwei Fingern zoomen' : 'Zum Zoomen ins Bild klicken';
    box.classList.add('is-open');
    document.documentElement.classList.add('dpvz-lock');
    show(idx);
    box.focus({ preventScroll: true });
  }
  function close(){
    box.classList.remove('is-open');
    document.documentElement.classList.remove('dpvz-lock');
    reset(false);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  /* Öffnen */
  wrap.addEventListener('click', function(e){
    if (e.target.closest('[data-dpv2-main]') || e.target.closest('.dpvz-hint')){ e.preventDefault(); open(); }
  });

  btnClose.addEventListener('click', close);
  btnPrev.addEventListener('click', function(){ show(idx - 1); });
  btnNext.addEventListener('click', function(){ show(idx + 1); });

  document.addEventListener('keydown', function(e){
    if (!box.classList.contains('is-open')) return;
    if (e.key === 'Escape'){ e.preventDefault(); close(); }
    else if (e.key === 'ArrowLeft' && list.length > 1){ e.preventDefault(); show(idx - 1); }
    else if (e.key === 'ArrowRight' && list.length > 1){ e.preventDefault(); show(idx + 1); }
    else if (e.key === 'Tab'){
      var f = [].filter.call(box.querySelectorAll('button'), function(b){ return !b.hidden; });
      if (!f.length) return;
      var a = f.indexOf(document.activeElement);
      e.preventDefault();
      if (a < 0) a = e.shiftKey ? 0 : -1;
      f[(a + (e.shiftKey ? -1 : 1) + f.length) % f.length].focus();
    }
  });

  /* Gesten (Maus und Touch über Pointer Events) */
  var ptrs = {}, n = 0;
  var g = null, lastTap = 0, lastTapX = 0, lastTapY = 0;

  function pts(){ var a = []; for (var k in ptrs) a.push(ptrs[k]); return a; }

  stage.addEventListener('pointerdown', function(e){
    if (e.pointerType === 'mouse' && e.button !== 0) return;
    ptrs[e.pointerId] = { x: e.clientX, y: e.clientY };
    n = Object.keys(ptrs).length;
    try { stage.setPointerCapture(e.pointerId); } catch(_){}
    var p = pts();
    if (n === 2){
      var mx = (p[0].x + p[1].x) / 2, my = (p[0].y + p[1].y) / 2;
      var r = stage.getBoundingClientRect();
      g = { type: 'pinch', d: Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y) || 1, s: s,
            qx: (mx - (r.left + r.width / 2) - tx) / s, qy: (my - (r.top + r.height / 2) - ty) / s };
    } else if (n === 1){
      g = { type: 'one', x: e.clientX, y: e.clientY, tx: tx, ty: ty, t: Date.now(), moved: false, onImg: e.target === img, mouse: e.pointerType === 'mouse' };
    }
  });

  stage.addEventListener('pointermove', function(e){
    if (!box.classList.contains('is-open')) return;
    if (ptrs[e.pointerId]){ ptrs[e.pointerId].x = e.clientX; ptrs[e.pointerId].y = e.clientY; }
    if (e.pointerType === 'mouse' && s > 1.01 && !(g && g.type === 'pinch')){ follow(e.clientX, e.clientY); if (g) g.moved = g.moved || Math.hypot(e.clientX - g.x, e.clientY - g.y) > 6; return; }
    if (!g) return;
    if (g.type === 'pinch' && n >= 2){
      var p = pts();
      var d = Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y);
      var ns = Math.max(1, Math.min(4, g.s * d / g.d));
      var r = stage.getBoundingClientRect();
      var mx = (p[0].x + p[1].x) / 2 - (r.left + r.width / 2), my = (p[0].y + p[1].y) / 2 - (r.top + r.height / 2);
      s = ns; tx = mx - s * g.qx; ty = my - s * g.qy;
      clamp(); apply(false);
    } else if (g.type === 'one'){
      var dx = e.clientX - g.x, dy = e.clientY - g.y;
      if (Math.hypot(dx, dy) > 8) g.moved = true;
      if (s > 1.01){ tx = g.tx + dx; ty = g.ty + dy; clamp(); apply(false); }
      else if (!g.mouse){ tx = dx * .9; ty = Math.max(0, dy) * .6; apply(false); }
    }
  });

  function end(e){
    if (!ptrs[e.pointerId]) return;
    delete ptrs[e.pointerId];
    n = Object.keys(ptrs).length;
    if (!g) return;
    if (g.type === 'pinch'){
      if (n === 0){ if (s < 1.05) reset(true); g = null; }
      else { var p = pts()[0]; g = { type: 'one', x: p.x, y: p.y, tx: tx, ty: ty, t: Date.now(), moved: true, onImg: true, mouse: false }; }
      return;
    }
    if (e.type === 'pointercancel'){ if (s <= 1.01) reset(true); g = null; return; }
    var dx = e.clientX - g.x, dy = e.clientY - g.y;
    var quick = Date.now() - g.t < 350;
    if (!g.moved){
      if (g.mouse){
        if (g.onImg){ if (s > 1.01) reset(true); else { s = ZOOM; follow(e.clientX, e.clientY); } }
        else close();
      } else {
        var now = Date.now();
        if (now - lastTap < 300 && Math.hypot(e.clientX - lastTapX, e.clientY - lastTapY) < 30){
          lastTap = 0;
          if (s > 1.01) reset(true); else zoomAt(e.clientX, e.clientY, ZOOM, true);
        } else {
          lastTap = now; lastTapX = e.clientX; lastTapY = e.clientY;
          if (!g.onImg && s <= 1.01){
            var t0 = now;
            setTimeout(function(){ if (lastTap === t0 && box.classList.contains('is-open')) close(); }, 300);
          }
        }
      }
    } else if (s <= 1.01 && !g.mouse){
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) && list.length > 1){ show(idx + (dx < 0 ? 1 : -1)); }
      else if (dy > 90 && dy > Math.abs(dx)){ close(); }
      else reset(true);
    }
    g = null;
  }
  stage.addEventListener('pointerup', end);
  stage.addEventListener('pointercancel', end);
  stage.addEventListener('lostpointercapture', function(e){ if (ptrs[e.pointerId]) end(e); });

  /* Mausrad zoomt am Desktop */
  stage.addEventListener('wheel', function(e){
    if (!box.classList.contains('is-open')) return;
    e.preventDefault();
    var ns = Math.max(1, Math.min(4, s * (e.deltaY < 0 ? 1.15 : 1 / 1.15)));
    if (ns <= 1.01){ reset(true); return; }
    zoomAt(e.clientX, e.clientY, ns, false);
  }, { passive: false });

  window.addEventListener('resize', function(){ if (box.classList.contains('is-open')){ clamp(); apply(false); } });
})();
